import { myAxios } from "./axios";

export function getLogs(payload = {}, { page, limit } = {}) {
  const { dealId, ...rest } = payload;

  if (!dealId) {
    throw new Error("dealId is required to fetch logs.");
  }

  const config = {
    params: {
      page,
      limit,
      ...rest,
    },
  };

  return myAxios.get(`/logs/get/${dealId}`, config);
}

export function getLog(id) {
  return myAxios.get(`/logs/${id}`);
}

export const addLog = async (formData, dealId) => {
  const response = await myAxios.post(`/logs/${dealId}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export function editLog(id, data) {
  return myAxios.put(`/logs/${id}`, data);
}

export function deleteLog(id) {
  return myAxios.delete(`/logs/${id}`);
}

export function deleteLogFile(logId, fileUrl) {
  return myAxios.delete(`/logs/${logId}/files`, {
    data: { fileUrl }, 
    headers: {
      "Content-Type": "application/json",
    },
  });
}
